import axios, {AxiosResponse} from 'axios';
import {CommonApi} from "@/model/api/CommonApi"
import {CriteriaUrl} from "@/model/api/urls"

export class CriteriaApi {
  static execute(): Promise<AxiosResponse<CriteriaResp>> {
    return axios.get(CriteriaUrl, CommonApi.requestConfig())
      .catch(CommonApi.catchHandler)
  }
}

export interface TextFilterDto {
  id: string
  type: string
}

export interface SelectMultipleFilterDto {
  id: string
  type: string
  options: Array<string>
  locked?: boolean
}

export interface DateRangeFilterDto {
  id: string
  type: string
  dateFrom: string
  dateTo: string
}

export interface CriteriaResp {
  filters: Array<TextFilterDto | SelectMultipleFilterDto | DateRangeFilterDto>
  groupings: Array<string>
  defaultGroupings: Array<string>
  groupingsDate3_7: Array<string>
}